/** @format */

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { get_products } from "../store/reducers/homeReducer";
import TrunckText from "../utils/TrunckText";
import { devise } from "../utils/utils";

import Paginations from "./Paginations";
import Products from "./products/Products";
import Ratings from "./Ratings";
import Reviews from "./Reviews";

//const ComposentDetails = ({setState, state, product, AfficheReview, moreProducts,relatedProducts}) => {

const ComposentDetails = ({
  setState,
  state,
  product,
  moreProducts,
  relatedProducts,
  customerInfo,
  reviewsSuccess,
  rating_review,
  reviews,
  totalReviews,
  parPage,
  reviewsError,
  currentPage,
  t,
}) => {
  const dispatch = useDispatch();
  const { latestProducts } = useSelector((state) => state.home);
  useEffect(() => {
    dispatch(get_products());
  }, [dispatch]);

  return (
    <div>
      <section>
        <div className='w-[95%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16'>
          <div className='flex flex-wrap'>
            <div className='w-[75%] md-lg:w-full'>
              <div className='pr-4 md-lg:pr-0'>
                <div className='grid grid-cols-2'>
                  <button
                    onClick={() => setState("reviews")}
                    className={`py-2 px-5 hover:bg-green-500  hover:text-white ${
                      state === "reviews"
                        ? "bg-green-500 text-white"
                        : "bg-slate-200 text-slate-700"
                    } rounded-sm`}
                  >
                    {t("Reviews")}
                  </button>
                  <button
                    onClick={() => setState("description")}
                    className={`py-2 px-5 hover:bg-green-500 hover:text-white ${
                      state === "description"
                        ? "bg-green-500 text-white"
                        : "bg-slate-200 text-slate-700"
                    } rounded-sm`}
                  >
                    Description
                  </button>
                </div>
                <div>
                  {/*
                                    state === 'reviews' ? <AfficheReview/>: <div className='p-5 text-justify text-gray-500'>
                                        <div className='md-lg:flex'>
                                            <TrunckText text={product.description} maxLength={500}/>
                                        </div>
                                    </div>*/}

                  {state === "reviews" ? (
                    <Reviews
                      productId={product._id}
                      customerInfo={customerInfo}
                      reviewsSuccess={reviewsSuccess}
                      rating_review={rating_review}
                      reviews={reviews}
                      totalReviews={totalReviews}
                      parPage={parPage}
                      reviewsError={reviewsError}
                      currentPage={currentPage}
                    />
                  ) : (
                    <div className='p-5 text-justify text-gray-500'>
                      <div className='md-lg:flex'>
                        <TrunckText
                          text={product.description}
                          maxLength={500}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='w-[25%] md-lg:w-[45%] sm:w-[100%]'>
              <div className='pl-4 md-lg:pl-0'>
                <div className='px-3 py-2 text-slate-600 bg-slate-200 rounded'>
                  <h2 className='text-lg font-bold '>
                    {" "}
                    {t("From")} {product.shopName}
                  </h2>
                </div>
                <div className='flex flex-wrap gap-8 mt-3 border p-3 justify-center items-center'>
                  {moreProducts.map((moreProduct, index) => {
                    return (
                      <Link
                        key={index}
                        to={`/product/details/${moreProduct._id}`}
                        className='border block w-[95%] justify-center items-center'
                      >
                        <div className='relative '>
                          <img
                            src={moreProduct.images[0].url}
                            alt=''
                            className='h-[170px] w-full object-contain'
                          />
                          {moreProduct.discount > 0 && (
                            <div
                              className='flex justify-center items-center absolute text-white w-[28px] h-[28px] rounded-full bg-red-500 
                                                    font-semibold text-sm left-2 top-2 '
                            >
                              {moreProduct.discount}%
                            </div>
                          )}
                        </div>
                        <div className='py-3 text-slate-600 px-2 '>
                          <h2 className='text-sm'>{moreProduct.name} </h2>
                          <div className='flex justify-start items-center gap-3'>
                            <span className='text-sm font-bold text-blue-800'>
                              {moreProduct.price} {devise}
                            </span>
                            <div className='flex'>
                              <Ratings ratings={moreProduct.rating} />
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className='overflow-hidden md-lg:w-[45%] hidden md-lg:flex'>
              <Products title='New Products' products={latestProducts} />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className='w-[95%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16'>
          <h2 className='text-2xl py-8 text-slate-600'>
            {t("Related products")}
          </h2>
          <div className='mt-4'>
            <Swiper
              slidesPerView='auto'
              breakpoints={{
                1200: { slidesPerView: 4 }, // Ajuste en fonction du nombre d'éléments
                565: { slidesPerView: 2 },
                340: { slidesPerView: 1 },
              }}
              spaceBetween={25}
              loop={false} // Désactiver si le nombre d'éléments est inférieur à `slidesPerView`
              pagination={{
                clickable: true,
                el: ".custom_bullet",
              }}
              modules={[Paginations]}
              className='mySwiper'
              autoplay={true}
            >
              {relatedProducts.map((relatedProduct, index) => (
                <SwiperSlide key={index} className='!w-[250px] flex-shrink-0'>
                  <Link
                    className='border block'
                    to={`/product/details/${relatedProduct._id}`}
                  >
                    <div className='relative h-[170px] w-auto'>
                      <div className='w-full h-full'>
                        <img
                          src={relatedProduct.images[0].url}
                          alt=''
                          className='w-full h-full object-contain'
                        />
                        <div className='absolute h-full w-full top-0 left-0 bg-[#000] opacity-25 hover:opacity-50 transition-all duration-200'></div>
                      </div>
                      {relatedProduct.discount ? (
                        <div
                          className='flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 
                                        font-semibold text-sm left-2 top-2 '
                        >
                          {relatedProduct.discount}%
                        </div>
                      ) : null}
                    </div>
                    <div className='p-4 flex flex-col gap-1'>
                      <h2 className='text-md text-slate-600 font-semibold'>
                        {relatedProduct.name}
                      </h2>
                      <div className='flex justify-start items-center gap-3'>
                        <h2 className='text-[#2424a8] font-bold'>
                          {relatedProduct.price} {devise}
                        </h2>
                        <div className='flex'>
                          <Ratings ratings={relatedProduct.rating} />
                        </div>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className='w-full flex justify-center items-center py-10'>
            <div className='custom_bullet justify-center gap-3 !w-auto'></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComposentDetails;
